import { z } from "zod";

export enum ECountry {
  FRANCE = "FRANCE",
  BELGIUM = "BELGIUM",
  FINLAND = "FINLAND",
  SLOVENIA = "SLOVENIA",
  SWEDEN = "SWEDEN",
  GREAT_BRITAIN = "GREAT_BRITAIN",
  SPAIN = "SPAIN",
  CZECH = "CZECH",
  HUNGARY = "HUNGARY",
  UNKNOWN = "UNKNOWN",
}

export enum ECountryCode {
  FRANCE = "FR",
  BELGIUM = "BE",
  FINLAND = "FI",
  SLOVENIA = "SI",
  SWEDEN = "SE",
  GREAT_BRITAIN = "GB",
  SPAIN = "ES",
  CZECH = "CZ",
  HUNGARY = "HU",
}

export enum ELanguageCode {
  FRENCH = "fr",
  FINNISH = "fi",
  SLOVENE = "sl",
  SWEDISH = "sv",
  ENGLISH_UK = "en-GB",
  SPANISH = "es",
  CZECH = "cs",
  HUNGARIAN = "hu",
}

export const countryCodeValidator = z.nativeEnum(ECountryCode);

export const COUNTRY_CODE_TO_COUNTRY: Record<ECountryCode, ECountry> = {
  [ECountryCode.FRANCE]: ECountry.FRANCE,
  [ECountryCode.BELGIUM]: ECountry.BELGIUM,
  [ECountryCode.FINLAND]: ECountry.FINLAND,
  [ECountryCode.SLOVENIA]: ECountry.SLOVENIA,
  [ECountryCode.SWEDEN]: ECountry.SWEDEN,
  [ECountryCode.GREAT_BRITAIN]: ECountry.GREAT_BRITAIN,
  [ECountryCode.SPAIN]: ECountry.SPAIN,
  [ECountryCode.CZECH]: ECountry.CZECH,
  [ECountryCode.HUNGARY]: ECountry.HUNGARY,
};
